import React from 'react';
import {Container} from 'tabler-react'

const MainFooter = (props) => {
    return(
        <div className="footer-div">
            <Container>
                Copyright © 2020 BetaHubs.
            </Container>
      </div>
    )
}
export default MainFooter;